import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { API_BASE_URL } from '../../config/config';
import './login.css';

function LoginModal({ show, onClose, onLoginSuccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

    const apiLogin = async (username, password) => {
    const response = await fetch(`${API_BASE_URL}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password })
    });
    const data = await response.json();
    return data;
  };

  const apiForgotPassword = async (email) => {
    const response = await fetch(`${API_BASE_URL}/auth/forgot-password`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email })
    });
    const data = await response.json();
    return data;
  };

  const handleLogin = async () => {
    if (!username || !password) {
      Swal.fire({
        icon: 'warning',
        title: 'Warning!',
        text: 'Username and password are required!',
        confirmButtonText: 'OK'
      });
      return;
    }

    setIsLoading(true);
    
    try {
      console.log(`loginModal.js te username:${username} password:${password}`)
      // Call backend controller via routes
      const result = await apiLogin(username, password);
      
              if (result.success) {
          Swal.fire({
            icon: 'success',
            title: 'Success!',
            text: `Welcome ${result.user.username}! Login successful.`,
            confirmButtonText: 'Continue',
            timer: 2000,
            timerProgressBar: true
          }).then(() => {
            // Close modal on successful login
            onClose?.();
            
            // Store user data in localStorage
            localStorage.setItem('user', JSON.stringify(result.user));
            
                         // Call onLoginSuccess callback
             onLoginSuccess?.();
          });
        } else {
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: result.error,
          confirmButtonText: 'Try Again'
        });
      }
    } catch (error) {
      console.error('Login error:', error);
      Swal.fire({
        icon: 'error',
        title: 'System Error!',
        text: 'An error occurred during login: ' + error.message,
        confirmButtonText: 'OK'
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleRegisterDemand = () => {
    console.log('Register Demand clicked');
    // Burada register demand işlemi yapılabilir
    Swal.fire({
      icon: 'info',
      title: 'Information',
      text: 'Register Demand feature will be added soon!',
      confirmButtonText: 'OK'
    });
  };

  const handleForgotPassword = async () => {
    console.log('Forgot Password clicked');
    
    // Show input dialog for email
    const { value: email } = await Swal.fire({
      title: 'Password Reset',
      input: 'email',
      inputLabel: 'Enter your email address',
      inputPlaceholder: 'your@email.com',
      showCancelButton: true,
      confirmButtonText: 'Send Reset Link',
      cancelButtonText: 'Cancel',
      inputValidator: (value) => {
        if (!value) {
          return 'You need to enter an email address!';
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          return 'Please enter a valid email address!';
        }
      }
    });

    if (email) {
      try {
        const result = await apiForgotPassword(email);
        
        if (result.success) {
          Swal.fire({
            icon: 'success',
            title: 'Email Sent!',
            text: result.message,
            confirmButtonText: 'OK'
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error!',
            text: result.error,
            confirmButtonText: 'OK'
          });
        }
      } catch (error) {
        console.error('Forgot password error:', error);
        Swal.fire({
          icon: 'error',
          title: 'System Error!',
          text: 'An error occurred while processing your request.',
          confirmButtonText: 'OK'
        });
      }
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    handleLogin(); // Form submit'te login çalışsın
  };

  return (
    <Modal show={show} onHide={onClose} centered className="login-modal">
      <Modal.Header closeButton>
        <Modal.Title>Login</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="username" className="form-label">Username</label>
                  <input 
                    type="username" 
                    className="form-control" 
                    id="username" 
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required 
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="password" className="form-label">Password</label>
                  <input 
                    type="password" 
                    className="form-control" 
                    id="password" 
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required 
                  />
                </div>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="form-check">
                    <input 
                      type="checkbox" 
                      className="form-check-input" 
                      id="rememberMe"
                      checked={rememberMe}
                      onChange={(e) => setRememberMe(e.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="rememberMe">Remember me</label>
                  </div>
                  <a 
                    href="#" 
                    className="text-decoration-none"
                    onClick={handleForgotPassword}
                  >
                    Forgot password?
                  </a>
                </div>
                <div className="d-flex gap-2">
                  <Button 
                    type="submit" 
                    variant="success" 
                    className="flex-fill"
                    disabled={isLoading}
                  >
                    {isLoading ? 'Logging now...' : 'Login'}
                  </Button>
                  <Button 
                    type="button" 
                    variant="primary" 
                    className="flex-fill"
                    onClick={handleRegisterDemand}
                  >
                    Register Demand
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default LoginModal;


